import buttonLoader from '../utilities/buttonLoader';

var monthlySub = {};

monthlySub = {

  init: function () {
    var SubscriptionPayForm = document.querySelector('.SubscriptionPayForm');
    var forfallagjald = document.querySelector('.js-monthlySub-forfallagjald');
    var VariantSelect = document.querySelector('.js-monthlySub-variant');
    if (SubscriptionPayForm)
      this.bind(SubscriptionPayForm);
    if (SubscriptionPayForm)
      this.priceCheck();
    if (SubscriptionPayForm, VariantSelect)
      this.bindVariantSelect(VariantSelect);
    if (SubscriptionPayForm, forfallagjald)
      this.bindForfallagjald(forfallagjald);
  },
  bind: function (SubscriptionPayForm) {
    var me = this;
    SubscriptionPayForm.addEventListener("submit", function (e) {

      e.preventDefault();

      var m = SubscriptionPayForm.querySelector('.alert');

      if (m) {
        m.remove();
      }
      me.submit(SubscriptionPayForm);
    });
  },

  bindVariantSelect: function (VariantSelect) {
    VariantSelect.addEventListener("change", this.priceCheck, true);
  },

  bindForfallagjald: function (forfallagjald) {
    forfallagjald.addEventListener("change", this.priceCheck, true);
  },

  priceCheck: function () {
    var form = document.querySelector('.SubscriptionPayForm');

    if (form) {
      var button = form.querySelector('button[type=submit]');

      buttonLoader.start(button);

      //var data = new FormData(form);

      const data = {
        SubscriptionId: form && form['SubscriptionId'].value,
        VariantId: form && form['VariantId'].value,
        ContractSSN: form && form['ContractSSN'].value,
        Forfallagjald: form && form['Forfallagjald'].checked
      };

      return fetch('/umbraco/surface/Order/PriceCheck', {
          method: 'POST',
          headers: new Headers({
            'Content-type': 'application/json'
          }),
          body: JSON.stringify(data)
        })
        .then(res => {
          if (res.ok) {
            buttonLoader.reset(button);
            return res.json();
          } else {

            buttonLoader.reset(button);
          }
        })
        .then(json => {
          var breakdownWindows = form.querySelectorAll('.js-monthlySub-breakdown');

          if (breakdownWindows) {
            Array.prototype.forEach.call(breakdownWindows, (breakdownWindow) => {
              breakdownWindow.style.display = "block";
              var discount = breakdownWindow.querySelector('.js-monthlySub-discount-col');
              var grettMonthly = breakdownWindow.querySelector('.js-monthlySub-monthly-col');
              var grettMMCol = breakdownWindow.querySelector('.js-monthlySub-greittMM-col');
              var samningsgjaldCol = breakdownWindow.querySelector('.js-monthlySub-samningsgjald-col');
              var forfallagjaldCol = breakdownWindow.querySelector('.js-monthlySub-forfallagjald-col');

              var totalCol = breakdownWindow.querySelector('.js-monthlySub-total-col');
              var totalValueCol = breakdownWindow.querySelector('.js-monthlySub-totalvalue-col');

              if (totalCol) {
                totalCol.innerHTML = json.prePaymentString;
              }

              if (totalValueCol) {
                totalValueCol.innerHTML = json.prePaymentWithCurrency;
              }

              if (grettMMCol) {
                if (json.greittMM > 0) {
                  grettMMCol.querySelector('.receipt__orderPrice').innerHTML = json.greittMMString;
                  grettMMCol.style.display = "flex";
                } else {
                  grettMMCol.style.display = "none";
                }
              }

              if (grettMonthly) {
                if (json.monthly > 0) {
                  grettMonthly.querySelector('.receipt__orderPrice').innerHTML = json.monthlyString;
                  grettMonthly.style.display = "flex";
                } else {
                  grettMonthly.style.display = "none";
                }
              }

              if (discount) {
                if (json.discountAmount > 0) {
                  discount.querySelector('.receipt__orderPrice').innerHTML = "-" + json.discountAmountString;
                  discount.style.display = "flex";
                } else {
                  discount.style.display = "none";
                }
              }

              if (samningsgjaldCol)
                if (json.samningsGjald > 0) {
                  samningsgjaldCol.querySelector('.receipt__orderPrice').innerHTML = json.samningsgjaldString;
                  samningsgjaldCol.style.display = "flex";
                }
                else
                  samningsgjaldCol.style.display = "none";
              if (forfallagjaldCol)
                if (json.forfallagjald > 0) {
                  forfallagjaldCol.querySelector('.receipt__orderPrice').innerHTML = json.forfallagjaldString;
                  forfallagjaldCol.style.display = "flex";
                }
                else
                  forfallagjaldCol.style.display = "none";
            });
          }
        })
        .catch(err => {
          buttonLoader.reset(button);
        });
    }
  },
  submit: function (form) {
    var me = this;

    var button = form.querySelector('button[type=submit]');
    var buttonWrapper = form.querySelector('.js-monthlySub-finalFormButtons');

    buttonLoader.start(button);

    var data = new FormData(form);

    var xhr = new XMLHttpRequest();
    xhr.open(form.getAttribute("method"), form.getAttribute("action"));

    xhr.onload = function () {

      var resp = JSON.parse(xhr.response);

      if (xhr.status >= 200 && xhr.status < 300) {

        if (resp.success) {
          window.location = "/vefverslun/samningur/kvittun";

        } else {

          buttonLoader.reset(button);

          me.renderMessage(buttonWrapper, resp.message, 'error');
        }

      } else {

        buttonLoader.reset(button);

        me.renderMessage(buttonWrapper, 'Server error', 'error');
      }

    };

    xhr.send(data);
  },

  renderMessage: function (el, message, type) {
    el.insertAdjacentHTML('afterend', '<div class="alert ' + type + '">' + message + '</div>');

  }
}

monthlySub.initialize = function () {
  monthlySub.init();
};

module.exports = monthlySub;
